import React, {} from "react"
import {
   FaHeart,
   FaEye,
} from 'react-icons/fa';
import '../../../css/InfluencerUpload.css'
import CommentDiv from './CommentDiv';


export default function make_block_content_info(content_info, content_array_name, data_func, display_icon_image = true) {
   var like_button_id = 'inf_scroll_3_n_likes_icon_' + content_info['id'];
   if (content_info['content_like'] == 1) {
      var button_style = {
         color: 'red',
      }
      var like_button = <button style={button_style} className="inf_scroll_3_n_likes_icon" id={like_button_id}
                                onClick={e => this.like_button_click(e, true, content_info['id'], 0, content_array_name, data_func)}>
         <FaHeart/></button>
   } else if (content_info.content_like == 0) {
      var button_style = {
         color: '#B7B7B7',
      }
      var like_button = <button style={button_style} className="inf_scroll_3_n_likes_icon" id={like_button_id}
                                onClick={e => this.like_button_click(e, true, content_info['id'], 1, content_array_name, data_func)}>
         <FaHeart/></button>
   }
   if (display_icon_image) {
      let icon_image = content_info['icon_image_file'];
      var icon_image_div = (
         <div className="inf_scroll_3_icon_image_all">
            <div className="inf_scroll_3_username"><h4>{content_info['influencer']}</h4></div>
            <div className="inf_scroll_3_icon_image">
               <img oncontextmenu={() => {
                  return false;
               }} src={icon_image} className="rounded-circle" width="100%" height="100%"/>
            </div>
         </div>
      )
   } else {
      var icon_image_div = ""
   }
   var like_id = 'inf_scroll_3_n_likes_' + content_info['id'];
   return (
      <div className="content_scroll_bottom_info_block">
         {icon_image_div}
         <div className="inf_scroll_3_name"> {content_info['name']}</div>
         <div className="inf_scroll_3_time_added"><p>{content_info['added']}</p></div>
         <div className="inf_scroll_3_n_views_icon"><FaEye/></div>
         <div className="inf_scroll_3_n_views"><p>{content_info['n_views']}</p></div>
         <div className="inf_scroll_3_n_likes" id={like_id}>{content_info['n_likes']}</div>
         {like_button}
         <CommentDiv type={'grid'}/>
      </div>
   )
}
